import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get, put, del, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member/enrollment";

export type WaivedBenefitPayloadType = {
	waivedActionValue: boolean;
};

export const editActionTakenAgainstWaive = async (
	_id: string,
	company: "nex" | "veb",
	group_number: number,
	waivedBenefitPayload: WaivedBenefitPayloadType
) => {
	try {
		const endpoint = `${initialRoute}/${company}/${group_number}/waive-action/${_id}`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, waivedBenefitPayload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
